import { Component } from '@angular/core';
import { ResumeService } from '../resume.service';

@Component({
  selector: 'create-online-resume',
  standalone: false,
  templateUrl: './create-online-resume.component.html',
  styleUrl: './create-online-resume.component.scss'
})
export class CreateOnlineResumeComponent  {
  public id: string = null;
  public resume: File = null;

  constructor(private resumeService: ResumeService) { }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement
    if (input.files && input.files.length > 0) {
      this.resume = input.files[0];
    }
  }

  generateResume() {
    const formData = new FormData();
    formData.append('resume', this.resume, this.resume.name);
    this.resumeService.generateResume(this.id, 'white', formData).subscribe((createdResumeId: string) => {
      if (!createdResumeId) {
        //jeb this.snackBar.open('Login Failed!', 'Please Try Again', { duration: 10000, horizontalPosition: 'center' });
        //const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));//jeb gotta redo the html, redo offer component ?
        //snackbar.open();
      } else {
        window.location.href = 'https://www.matrix.tools/resumes/' + createdResumeId;
      }
    }, (error) => {
      console.error(error);

      //jeb this.snackBar.open('Login Failed!', 'Please Try Again', { duration: 10000, horizontalPosition: 'center' });
      //const snackbar = new MDCSnackbar(document.querySelector('.mdc-snackbar'));//jeb gotta redo the html, redo offer component ?
      //snackbar.open();
    });
  }
}
